
if ('IntersectionObserver' in window) {
    const headerObserver = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach(e => {
                if (e.intersectionRatio > 0) {
                    document.querySelector('body').classList.remove('scrolled');
                } else {
                    document.querySelector('body').classList.add('scrolled');
                }
            });
        });

    headerObserver.observe(document.querySelector('.header-observer'));
}